import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormlyModule } from "@ngx-formly/core";
import { AlertModule } from "@vp/shared/components/alert";
import { FlexModule } from "@vp/shared/directives/flex";
import { ContextDisplayModule } from "@vp/shared/pipes/context-display";
import { SpinnerModule } from "@vp/shared/spinner";
import { AddFormComponent } from "./add-form/add-form.component";
import { EditCaseCostComponent } from "./edit-case-cost/edit-case-cost.component";
@NgModule({
  imports: [
    AlertModule,
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: "edit-case-cost",
          component: EditCaseCostComponent
        }
      ]
    }),
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    ReactiveFormsModule,
    SpinnerModule,
    MatChipsModule,
    ContextDisplayModule,
    FlexModule
  ],
  declarations: [EditCaseCostComponent, AddFormComponent],
  exports: []
})
export class FormlyEditCaseCostModule {}
